// extracted by mini-css-extract-plugin
export var productImage = "_xg-0";